import Cookies from 'js-cookie'

const TokenKey = 'TOKEN'
const RefreshToken = 'REFRESHTOKEN'
const SessionId = 'JSESSIONID'


export function getToken() {
  const token = Cookies.get(TokenKey)
  return token
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRefreshToken() {
  const token = Cookies.get(RefreshToken)
  return token
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshToken, token)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshToken)
}

export function getSessionId() {
  const token = Cookies.get(SessionId)
  return token
}

export function setSessionId(token) {
  return Cookies.set(SessionId, token)
}

export function removeSessionId() {
  return Cookies.remove(SessionId)
}

export default {
  getToken,
  setToken,
  removeToken,
  getRefreshToken,
  setRefreshToken,
  removeRefreshToken,
  getSessionId,
  setSessionId,
  removeSessionId
}
